<template>
<div class="cp_tabs">
    <div class="row">
        <div class="col-6">
            <div class="form-group">
                <select class="form-control" name="OnlineType" data-placeholder="Online Type" v-model="OnlineType" v-validate="'required'">
                    <option value="pancakes">Skrill</option>
                    <option value="pancakes">Skrill 1</option>
                    <option value="pancakes">Skrill 2</option>
                </select>
                <span v-show="submitted && errors.has('OnlineType')" class="text-danger">Online Type is required</span>
            </div>
        </div>
        <div class="col-6">
            <div class="form-group">
                <input type="text" class="form-control" name="online_id" v-model="online_id" v-validate="'required'">
                <label class="labeltext">Your ID</label>
                <span v-show="submitted && errors.has('online_id')" class="text-danger">Your ID is required</span>
            </div>
        </div>
        <div class="col-12">
            <h4>Instructions</h4>
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. </p>
        </div>

        <div class="col-12 text-center">
            <input type="submit" class="cap_btn blue" value="Add Now" @click.stop.prevent="OnlinePayFunc()">
        </div>
    </div>
</div>
</template>

<script>
export default {
    name: 'bank',
    data() {
        return {
            pageLoader : false,
            submitted: false,
            
            OnlineType: '',
			online_id: '',
        }
    },
    methods: {
        OnlinePayFunc(){
			const _that = this
			_that.submitted = true;
			_that.$validator.validate().then(valid => {
				if (valid) {
					console.log('abc1')
					let input_json={
						'globalParams' :{

						},
						'localParams' :{ "parameter" : _that }
					}
					_that.apiFunc(input_json)
				}
			});
		},
    },
}
</script>



// WEBPACK FOOTER //
// src/components/website/payment/methods/online.vue